var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePlus1357SvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "profile_plus [#1357]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-340.000000, -2079.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304,1922 L304,1924 L301,1924 L301,1927 L299,1927 L299,1924 L296,1924 L296,1922 L299,1922 L299,1919 L301,1919 L301,1922 L304,1922 Z M286.312,1937 C287.103,1934.633 289.33,1932.92 291.958,1932.902 C291.972,1932.902 291.985,1932.906 292,1932.906 C292.015,1932.906 292.028,1932.902 292.042,1932.902 C294.671,1932.92 296.899,1934.632 297.69,1937 L286.312,1937 Z M292,1926.906 C293.103,1926.906 294,1927.803 294,1928.906 C294,1929.995 293.125,1930.879 292.042,1930.902 C292.028,1930.902 292.014,1930.9 292,1930.9 C291.986,1930.9 291.972,1930.902 291.958,1930.902 C290.875,1930.879 290,1929.995 290,1928.906 C290,1927.803 290.897,1926.906 292,1926.906 L292,1926.906 Z M295.026,1931.495 C295.625,1930.796 296,1929.899 296,1928.906 C296,1926.697 294.209,1924.906 292,1924.906 C289.791,1924.906 288,1926.697 288,1928.906 C288,1929.899 288.375,1930.796 288.974,1931.495 C286.057,1932.686 284,1935.543 284,1938.89 C284,1938.93 284.024,1939 284.024,1939 L299.994,1939 C300.216,1936.566 298.564,1932.941 295.026,1931.495 L295.026,1931.495 Z",
    id: "profile_plus-[#1357]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlus1357SvgrepoCom);
export default __webpack_public_path__ + "static/media/profile-plus-1357-svgrepo-com.2243ed83fae0e85fee63238b0157e030.svg";
export { ForwardRef as ReactComponent };